import axios from 'axios';
import { 
    API_BASE_URL 
} from 'src/common/constants';

export default class SystemUpdateService {
	static getInstance() {
		if (!SystemUpdateService.instance) {
			SystemUpdateService.instance = new SystemUpdateService();
		}

		return SystemUpdateService.instance;
	}

	async fetchList(params  = {}) {
		const response = await axios.get(`${API_BASE_URL}/system_update/list`, {
            params: params,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('LOCAL_STORAGE_KEY_ACCESS_TOKEN')}`,
			}
		});

        return response.data?.data;
    }
}
